import React from 'react';
import { Trans, withTranslation } from "react-i18next";
import { Footer, Links } from "./ProfilePage.styled";
import { Component } from 'react';
import FloatingAlert from './../../components/FloatingAlert/FloatingAlert';
import axios from 'axios';
import { connect } from 'react-redux';
import envo from "../../environments/environmentProd";
import AuthContext from '../../ContextApi/AuthContext';
import * as bootstrap from 'bootstrap';

const apiUrl = envo.apiUrl;

const gamezoneUrl = window.location.href.includes("ao.playit");
const algeriaorUrl = window.location.href.includes("dzo");
const koreqUrl = window.location.href.includes("koreq") ;
const isLibya = window.location.hostname.includes("libya") || window.location.hostname.includes("localhost");

class ProfileFooter extends Component {
  static contextType = AuthContext;
  
  constructor() {
    super();
    this.state = {
      changePass: false,
      current: "",
      newPass: "",
      confirmNew: "",
      errors: false,
      errorMsg: "",
      success: false,
      successMsg: "",
      subscribeDate: "",
      renewalDate: '',
      plan: "",
      PackageCode: "",
      SubscriptionDate: "",
      canCancel: true,
    };
  }

  // get user data

  async componentDidMount() {
    if (gamezoneUrl) {
      document
        .getElementById("linkUnsubscribe")
        .setAttribute("class", "linkUnsubscribe");
    }
    this.setState({
      subscribeDate: this.context.userProfile.subscribeDate,
      renewalDate: this.context.userProfile.renewalDate,
      PackageCode: this.context.userProfile.PackageCode,
      SubscriptionDate: this.context.userProfile.SubscriptionDate,
    });

    if (isLibya) {

  try {
    const msisdn = JSON.parse(localStorage.getItem("phoneNum"));
    if (msisdn) {
      const res = await axios.get(`https://apissl.playit.mobi/api/v2/connex-libya/get-sub-details?msisdn=${msisdn}`);

     
        this.setState({
          subscribeDate: res.data.data.created_at,
          renewalDate: res.data.data.expiration_date,
          canCancel: res.data.data.can_cancel,

        });
        console.log(" rana = > " ,this.state.renewalDate , this.state.SubscriptionDate);
   
    }
  } catch (error) {
    console.error("Libya API call failed", error);
  }
}

  }
handleSubscriptionClick = (e) => {
  e.preventDefault();

  if (this.state.canCancel) {
    // Existing cancel behavior
    window.location.href =
      window.location.pathname.includes("brain-games")
        ? "/brain-games/unsubscribe"
        : window.location.pathname.includes("action-games")
        ? "/action-games/unsubscribe"
        : "/unsubscribe";
  } else {
    console.log("Subscription is not active or cannot be canceled.");

const myModal = new bootstrap.Modal(
  document.getElementById('confirmSubscribeModal'),
  { backdrop: false }
);
    myModal.show();

    const sureBtn = document.getElementById("confirmSubscribeBtn");
    sureBtn.onclick = async () => {
        axios.post(`https://apissl.playit.mobi/api/v2/connex-libya/send-otp-activate`, {msisdn: JSON.parse(localStorage.getItem("phoneNum"))})
        .then(res => {
          if (res.data.status === true) {
            window.location.href = "/verify-otp-activate";
           console.log("res",res)
           console.log("OTP sent successfully, redirecting to verify-otp page");
          }
         
        })
        .catch(function (error) {
          console.error("Error sending OTP for subscription:", error);
        })
        .finally(function () {
        });
        
    };
  }
};



  toggleView(e) {
    
    e.preventDefault();
    this.props.resitPasswordfun();
    this.setState({
      changePass: true,
    });
  }

  async changePassword(e) {
    e.preventDefault();
    const { current, newPass, confirmNew } = this.state;
    const options = {
      headers: { AUTHORIZATION: `Bearer ${localStorage.getItem("token")}` },
    };
    const params = {
      current: current,
      password: newPass,
    };
    try {
      if (!this.isMatched(newPass, confirmNew)) {
        this.setState({
          errors: true,
          errorMsg: "Confirm password not match new password",
        });
        return;
      }

      const res = await axios.post(
        `${apiUrl}/playit/password/update`,
        params,
        options
      );
      if (!res.data) return false;
      const data = res.data;
      if (data.status !== "success") {
        return false;
      }

      //TODO: After showing success message,route it view mode
      this.setState({
        success: true,
        successMsg: this.props.t("profile.password_changed"),
      });
    } catch (err) {
      if (err.response && err.response.status !== 200) {
        this.setState({
          errors: true,
          errorMsg: err.response.data.message,
        });
      }
      return false;
    }
  }

  onInputChange(name, value) {
    this.setState({
      [name]: value,
      errors: false,
    });
  }

  isMatched(newPass, confirmNew) {
    return newPass === confirmNew ? true : false;
  }
  render() {
    const { t } = this.props;
    const { changePass, errors, errorMsg, success, successMsg } = this.state;
    //FIXME: When showing floating alert it appears above submit btn (style height issue)
    return (
      <>
        {changePass && this.props.resitPassword ? (
          <Footer>
            <form
              onSubmit={(e) => {
                this.changePassword(e);
              }}
            >
              <div className="form">
                <div className="iconInput">
                  <i className="icon lock" />
                  <input
                    type="password"
                    className="input"
                    placeholder={t("profile.current")}
                    onChange={(e) =>
                      this.onInputChange("current", e.target.value)
                    }
                  />
                </div>
                <div className="iconInput">
                  <i className="icon lock" />
                  <input
                    type="password"
                    className="input"
                    placeholder={t("profile.new")}
                    onChange={(e) =>
                      this.onInputChange("newPass", e.target.value)
                    }
                  />
                </div>
                <div className="iconInput">
                  <i className="icon lock" />
                  <input
                    type="password"
                    className="input"
                    placeholder={t("profile.confirm")}
                    onChange={(e) =>
                      this.onInputChange("confirmNew", e.target.value)
                    }
                  />
                </div>
              </div>

              <div className="normBtn">
                <button className="btn" type="submit">
                  <Trans>profile.change</Trans>
                </button>
              </div>
              <div className="normBtn">
                <button
                  className="btn cancel-btn"
                  onClick={() => {
                    this.setState({ changePass: false });
                  }}
                >
                  <Trans>profile.cancel</Trans>
                </button>
              </div>
            </form>
            {errors ? (
              <FloatingAlert type="error">{errorMsg}</FloatingAlert>
            ) : (
              ""
            )}
            {success ? (
              <FloatingAlert type="success">{successMsg}</FloatingAlert>
            ) : (
              ""
            )}
          </Footer>
        ) : (
          <>
            <Footer>
              <div className="subscribeDate">
                <div className="calanader"></div>
                <span className="title">
                  <Trans>profile.subscription_date</Trans>
                </span>

                {algeriaorUrl ? (
                  <span className="date">{this.state.SubscriptionDate}</span>
                ) : (
                  <span className={`${koreqUrl ? 'data-korek' : 'date'}`}>{this.state.subscribeDate}</span>
                )}
              </div>

              <div className="renewalDate">
                <div className="calanader"></div>
                <span className="title">
                  <Trans>profile.renewal_date</Trans>
                </span>
                <span className={`${koreqUrl ? 'data-korek' : 'date'}`} >{this.state.renewalDate}</span>
              </div>
            </Footer>
            {algeriaorUrl ? (
              <Footer>
                <div className="renewalDate">
                  <div className="calanader"></div>
                  <span className="title">
                    <Trans>profile.plan</Trans>
                  </span>

                  {this.state.PackageCode == "d" ||
                  this.state.PackageCode == "D" ? (
                    <span className="date">
                      <Trans>dailyalgeraplan</Trans>
                    </span>
                  ) : (
                    ""
                  )}
                  {this.state.PackageCode == "W" ||
                  this.state.PackageCode == "w" ? (
                    <span className="date">
                      <Trans>weeklyalgeraplan</Trans>
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </Footer>
            ) : null}
            <Links>
              {/* <a href=" " onClick={(e) => this.toggleView(e)}>
                  <Trans>profile.reset_my_password</Trans>
                </a> */}
            {!isLibya && !koreqUrl && (
  <a
    href={
      window.location.pathname.includes("brain-games")
        ? "/brain-games/unsubscribe"
        : window.location.pathname.includes("action-games")
        ? "/action-games/unsubscribe"
        : "/unsubscribe"
    }
    id="linkUnsubscribe"
  >
    <Trans>unsubscribe</Trans>
  </a>
)}

              {isLibya ? (
    <a href="#" onClick={this.handleSubscriptionClick} id="linkSubControl">
      <Trans>{this.state.canCancel ? "unsubscribe" : "subscribe"}</Trans>
    </a>
  ) : ''}
            </Links>
          </>
        )}
<div
  class="modal fade"
  id="confirmSubscribeModal"
  tabindex="-1"
  aria-labelledby="confirmSubscribeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body text-center text-black">
       <Trans>Are you sure you want to subscribe again?</Trans>
      </div>
      <div class="modal-footer justify-content-center">
        <button type="button" style={{background:'red'}} class="btn btn-danger" data-bs-dismiss="modal"><Trans>Cancel</Trans></button>
        <button type="button" class="btn btn-primary" id="confirmSubscribeBtn"><Trans>Sure</Trans></button>
      </div>
    </div>
  </div>
</div>

      </>
    );
  }
}

/* Start Update State Use REDUX */
function mapStateToProps(state) {
  return {
    resitPassword: state.resitPassword
  }
}

function mapDispatchToProps(dispatch) {
  return {
    editeInfoFun: () => dispatch({ type: 'EDITINFO' }),
    resitPasswordfun: () => dispatch({ type: 'RESITPASSWORD' })
  }
}

/* End Update State Use REDUX */
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ProfileFooter))
